import Vue from 'vue';
import Vuex from 'vuex';
// 租赁
import asset from './modules/asset';
import enumStore from './modules/enum';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		asset,
		enumStore,
	},
});
